import * as Api from './service'
export default {
  namespace: 'insuranceMain',
  state: {
    handbookUrl: '',
    insuranceFlag: false,
    buyIns: false,
    hasActivity: false,
    showable: false,
    content: '',
    linkUrl: '',
    govConfigData: {}
  },
  effects: {
    * getConfigData ({ payload }, { call, put }) {
      const res = yield call(Api.getConfigData, payload)
      const result = res.data.data
      // console.log(res.data)
      yield put({
        type: 'queryData',
        payload: {
          handbookUrl: result && result.handbookUrl,
          insuranceFlag: result && result.insuranceFlag
        }
      })
      return res.data
    },
    * getHomeData ({ payload }, { call, put }) {
      const res = yield call(Api.getHomeData, payload)
      const result = res.data.data
      // console.log(res.data)
      yield put({
        type: 'queryData',
        payload: {
          buyIns: result ? result.buyIns : false,
          hasActivity: result ? result.hasActivity : false,
          showable: result ? result.showable : false,
          content: result ? result.content : ''
        }
      })
      return res.data
    },
    // 购买
    * buyInsurance ({ payload }, { call, put }) {
      const {
        data
      } = yield call(Api.buyInsurance, payload)
      yield put({
        type: 'queryData',
        payload: {
          linkUrl: data.data.url
        }
      })
    },
    * govConfig ({ payload }, { call, put }) {
      const {
        data
      } = yield call(Api.govConfig, payload)
      yield put({
        type: 'queryData',
        payload: {
          govConfigData: data.data
        }
      })
      return data
    }
  },

  reducers: {
    queryData (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
